/**
 * `condition && value` as a function call so it doesn't count as a branch
 * for ESLint's `complexity` rule.
 * @param {boolean} condition
 * @param {number|string} value
 * @returns {number|string|boolean}
 */
export const valueCondition = (condition, value) => condition && value;
